import React, { useEffect, useState } from 'react';
import './index.less';

interface TabItem {
  key: string;
  label: string;
}

interface CustomTabsProps {
  items: TabItem[];
  defaultActiveKey?: string;
  onChange?: (activeKey: string) => void;
  className?: string;
}

const CustomTabs: React.FC<CustomTabsProps> = ({
  items,
  defaultActiveKey,
  onChange,
  className = '',
}) => {

  const [activeKey, setActiveKey] = useState(defaultActiveKey || items[0]?.key || ''); 
  const handleTabClick = (key: string) => {
    setActiveKey(key);
    onChange?.(key);
  };
  useEffect(() => {
    if (defaultActiveKey) {
      setActiveKey(defaultActiveKey);
    }
  }, [defaultActiveKey]);
  return (
    <div className={`custom-tabs ${className}`}> 
      <div className="custom-tabs-nav">
        {items.map((item,index) => (
          <div
            key={item.key}
            className={`custom-tab-item ${activeKey === item.key ? 'active' : ''}`}
            onClick={() => handleTabClick(item.key)}
          >
            <span className="custom-tab-label">{item.label}</span>
          </div>
        ))} 
      </div>
    </div>
  );
};

export default CustomTabs;
